import { APP_INITIALIZER, NgModule } from '@angular/core';
import { TRANSLOCO_CONFIG, TRANSLOCO_LOADER, TranslocoModule, TranslocoService, translocoConfig } from '@ngneat/transloco';
import { LOCALE_DEFAULT_LOCALE, TRANSLOCO_NUMBER_TRANSFORMER, TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { TranslocoMessageFormatModule } from '@ngneat/transloco-messageformat';
import { TranslocoHttpLoader } from 'app/fuse-template/core/transloco/transloco.http-loader';
import { TranslationService } from 'app/services/api/translation/translation.service';
import { environment } from 'environments/environment';
import { CustomNumberTransformer } from './transformers/customNumberTransformer';

@NgModule({
    imports: [TranslocoMessageFormatModule.forRoot(), TranslocoLocaleModule.forRoot()],
    exports: [TranslocoModule, TranslocoLocaleModule],
    providers: [
        {
            // Provide the default Transloco configuration
            provide: TRANSLOCO_CONFIG,
            useValue: translocoConfig({
                availableLangs: [
                    {
                        id: 'is',
                        label: 'Icelandic',
                    },
                ],
                defaultLang: 'is',
                fallbackLang: 'is',
                reRenderOnLangChange: true,
                prodMode: environment.environment === 'production' || environment.environment === 'release',
            }),
        },
        {
            // Provide the default Transloco loader
            provide: TRANSLOCO_LOADER,
            useClass: TranslocoHttpLoader,
        },
        {
            provide: LOCALE_DEFAULT_LOCALE,
            useValue: 'is-IS',
        },
        {
            provide: TRANSLOCO_NUMBER_TRANSFORMER,
            useClass: CustomNumberTransformer,
        },
        {
            // Preload the default language before the app starts to prevent empty/jumping content
            provide: APP_INITIALIZER,
            deps: [TranslocoService, TranslationService],
            useFactory:
                (translocoService: TranslocoService, translationService: TranslationService): any =>
                () => {
                    const defaultLang = translocoService.getDefaultLang();
                    translocoService.setActiveLang(defaultLang);
                    translocoService.config.missingHandler.logMissingKey = false;
                    // Needs to return a promise for the initial sign in page to work
                    return new Promise<void>((resolve, reject) => {
                        translocoService.load(defaultLang).subscribe({
                            error: () => {
                                reject();
                            },
                            next: () => {
                                translationService.translationsChanged$.next(null);
                                resolve();
                            },
                        });
                    });
                },
            multi: true,
        },
    ],
})
export class TranslocoCoreModule {}
